import { NavLink } from "react-router-dom";
import { Trophy, LayoutGrid } from "lucide-react";
import { cn } from "@/lib/utils";

const tabs = [
  { to: "/top-5", label: "Top 5", icon: Trophy },
  { to: "/picks", label: "All Picks", icon: LayoutGrid },
];

export default function PicksTabs({ className }: { className?: string }) {
  return (
    <div
      role="tablist"
      className={cn(
        "inline-flex items-center gap-1 p-1 rounded-xl border border-border/60 bg-secondary/40 backdrop-blur-sm",
        className,
      )}
    >
      {tabs.map((t) => {
        const Icon = t.icon;
        return (
          <NavLink
            key={t.to}
            to={t.to}
            end
            className={({ isActive }) =>
              cn(
                "inline-flex items-center gap-1.5 px-4 py-1.5 rounded-lg text-sm font-medium transition-all",
                isActive
                  ? "bg-background text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground",
              )
            }
          >
            <Icon className="w-3.5 h-3.5" />
            {t.label}
          </NavLink>
        );
      })}
    </div>
  );
}
